module.exports = __webpack_public_path__ + "static/landingMobile@2x-387f573967107f900e9442829f28c562.png";